import ImageSelector from 'components/Shared/ImageSelector';
import DeleteIcon from 'mdi-react/DeleteIcon';
import { useState } from 'react';
import { getCdnUrl } from 'utils';
import defaultAvatar from 'assets/img/avatar.png';
import { Typography, makeStyles, alpha, IconButton } from '@material-ui/core';

interface IProps {
  width: number;
  height: number;
  disabled?: boolean;
  label: string;
  value: string;
  onChange: (image: string) => void;
}

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(6),
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'fill',
    borderRadius: 8,
    overflow: 'hidden',
  },
  label: {
    color: theme.palette.common.white,
  },
  imageContainer: {
    background: theme.palette.grey[300],
    marginTop: theme.spacing(2),
    position: 'relative',
    width: 200,
    height: 200,
    borderRadius: 8,
    overflow: 'hidden',
    '&:hover': {
      '& > div, > button': {
        display: 'flex',
      },
    },
  },
  hover: {
    display: 'none',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    background: alpha(theme.palette.common.white, 0.6),
    width: '100%',
    height: '100%',
    zIndex: 1,
    cursor: 'pointer',
  },
  icon: {
    display: 'none',
    position: 'absolute',
    right: 4,
    top: 4,
    color: theme.palette.error.main,
    zIndex: 5,
    cursor: 'pointer',
  },
}));

const ImageUploader = (props: IProps) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  const openImageSelector = () => {
    setOpen(true);
  };

  const onCompleteUpload = (image: string) => {
    setOpen(false);
    if (image) props.onChange(image);
  };

  const removeImage = () => {
    props.onChange('');
  };

  return (
    <div className={classes.root}>
      <Typography variant='body1' className={classes.label}>
        {props.label}
      </Typography>

      {open && <ImageSelector opened={open} width={props.width} height={props.height} onComplete={onCompleteUpload} />}

      <div className={classes.imageContainer} data-disabled={props.disabled}>
        <img
          src={getCdnUrl(props.value, defaultAvatar)}
          alt='foto do perfil'
          className={classes.image}
          id='profile-change-profile-image'
        />
        <IconButton className={classes.icon} onClick={removeImage} id='profile-delete-profile-image'>
          <DeleteIcon />
        </IconButton>
        <div className={classes.hover} onClick={openImageSelector}>
          <Typography variant='body1'>Alterar foto</Typography>
        </div>
      </div>
    </div>
  );
};

export default ImageUploader;
